import { render, staticRenderFns } from "./PasswordSet.vue?vue&type=template&id=f4a451de"
import script from "./PasswordSet.vue?vue&type=script&lang=ts"
export * from "./PasswordSet.vue?vue&type=script&lang=ts"
import style0 from "./PasswordSet.vue?vue&type=style&index=0&id=f4a451de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports